import React from 'react';

import Button from 'koba/components/Button';
import Icon from 'koba/components/Icon';
import { Caption, P } from 'koba/components/Typography';
import { TFunction } from 'next-i18next';
import { FileSizeLabel } from 'components/FileSizeLabel';
import { LoadingSpinner } from '@thinkific/chalk';
import { Attachment } from 'schema/Post/types';
import styles from './AttachmentPreview.module.scss';

interface FilePreviewProps {
  attachments: Attachment[];
  onRemove(index: number): void;
  t: TFunction; // Would be better to pass in the translated strings used here
}

const FilePreview = ({ attachments, onRemove, t }: FilePreviewProps) => {
  return (
    <div className={styles['file-container-wrapper']}>
      {attachments.map((attachment: Attachment, index: number) => {
        const { fileName, fileSizeInBytes } = attachment;
        return (
          <div
            aria-live="polite"
            className={styles['file-container']}
            data-qa="file-attachment__file-preview"
            id="file-attachment-preview"
            key={attachment.url}
            role="region"
            title={t('File Preview')}
          >
            {attachment.isLoading ? (
              <div className={styles['file-container__loading-spinner']}>
                <LoadingSpinner size="lg" />
              </div>
            ) : (
              <Icon
                className={styles['file-container__icon']}
                name="document"
              />
            )}
            <P className={styles['file-container__name']} title={fileName}>
              {fileName}
              {/* @ts-ignore - Can remove this once we convert the Caption component */}
            </P>
            <Caption className={styles['file-container__size']}>
              <FileSizeLabel byteCount={fileSizeInBytes as number} t={t} />
            </Caption>
            {/* @ts-ignore - Can remove this once we convert the Button component */}
            <Button
              appearance="knockout"
              ariaLabel={t('Remove attachment')}
              className={styles['remove-file-button']}
              data-qa="file-attachment__remove-button"
              isDisabled={attachment.isLoading}
              size="x-small"
              onClick={() => onRemove(index)}
            >
              <Icon name="x-dismiss" />
            </Button>
          </div>
        );
      })}
    </div>
  );
};

export default FilePreview;
